module.exports = __webpack_public_path__ + "static/the-ride-of-a-lifetime-e2e8e4e20c8a52e576ae8c1ab27989e0.jpg";